// extracted by mini-css-extract-plugin
module.exports = {"images":"TokenPair_images__rSFf5","fill":"TokenPair_fill__3cd1-","outline":"TokenPair_outline__lmq9F","text":"TokenPair_text__paWBM"};